type CommerceLanguage = {
  name: string;
  tag: string;
};

// list of all the languages for the list of locales provided in commerceCurrencyLocales
export const commerceLanguages: Array<CommerceLanguage> = [
  {name: 'Afar', tag: 'aa'},
  {name: 'Afrikaans', tag: 'af'},
  {name: 'Aghem', tag: 'agq'},
  {name: 'Akan', tag: 'ak'},
  {name: 'Albanian', tag: 'sq'},
  {name: 'Alsatian', tag: 'gsw'},
  {name: 'Amharic', tag: 'am'},
  {name: 'Arabic', tag: 'ar'},
  {name: 'Armenian', tag: 'hy'},
  {name: 'Assamese', tag: 'as'},
  {name: 'Asturian', tag: 'ast'},
  {name: 'Asu', tag: 'asa'},
  {name: 'Azerbaijani (Cyrillic)', tag: 'az-Cyrl'},
  {name: 'Azerbaijani (Latin)', tag: 'az-Latn'},
  {name: 'Bafia', tag: 'ksf'},
  {name: 'Bamanankan (Latin)', tag: 'bm-Latn'},
  {name: 'Bangla', tag: 'bn'},
  {name: 'Basaa', tag: 'bas'},
  {name: 'Bashkir', tag: 'ba'},
  {name: 'Basque', tag: 'eu'},
  {name: 'Belarusian', tag: 'be'},
  {name: 'Bemba', tag: 'bem'},
  {name: 'Bena', tag: 'bez'},
  {name: 'Blin', tag: 'byn'},
  {name: 'Bodo', tag: 'brx'},
  {name: 'Bosnian (Cyrillic)', tag: 'bs-Cyrl'},
  {name: 'Bosnian (Latin)', tag: 'bs-Latn'},
  {name: 'Breton', tag: 'br'},
  {name: 'Bulgarian', tag: 'bg'},
  {name: 'Burmese', tag: 'my'},
  {name: 'Catalan', tag: 'ca'},
  {name: 'Central Atlas Tamazight ', tag: 'tzm'},
  {name: 'Central Kurdish', tag: 'ku-Arab'},
  {name: 'Chechen', tag: 'cd'},
  {name: 'Cherokee', tag: 'chr-Cher'},
  {name: 'Chiga', tag: 'cgg'},
  {name: 'Chinese (Simplified)', tag: 'zh'},
  {name: 'Chinese (Traditional)', tag: 'zh'},
  {name: 'Church Slavic', tag: 'cu'},
  {name: 'Cornish', tag: 'kw'},
  {name: 'Corsican', tag: 'co'},
  {name: 'Croatian', tag: 'hr'},
  {name: 'Croatian (Latin)', tag: 'hr'},
  {name: 'Czech', tag: 'cs'},
  {name: 'Danish', tag: 'da'},
  {name: 'Dari', tag: 'prs'},
  {name: 'Divehi', tag: 'dv'},
  {name: 'Duala', tag: 'dua'},
  {name: 'Dutch', tag: 'nl'},
  {name: 'Dzongkha', tag: 'dz'},
  {name: 'Embu', tag: 'ebu'},
  {name: 'English', tag: 'en'},
  {name: 'Estonian', tag: 'et'},
  {name: 'Ewe', tag: 'ee'},
  {name: 'Ewondo', tag: 'ewo'},
  {name: 'Faroese', tag: 'fo'},
  {name: 'Filipino', tag: 'fil'},
  {name: 'Finnish', tag: 'fi'},
  {name: 'French', tag: 'fr'},
  {name: 'Frisian', tag: 'fy'},
  {name: 'Friulian', tag: 'fur'},
  {name: 'Fulah (Latin)', tag: 'ff-Latn'},
  {name: 'Fulah', tag: 'ff'},
  {name: 'Galician', tag: 'gl'},
  {name: 'Ganda', tag: 'lg'},
  {name: 'Georgian', tag: 'ka'},
  {name: 'German', tag: 'de'},
  {name: 'Greek', tag: 'el'},
  {name: 'Greenlandic', tag: 'kl'},
  {name: 'Guarani', tag: 'gn'},
  {name: 'Gujarati', tag: 'gu'},
  {name: 'Gusii', tag: 'guz'},
  {name: 'Hausa (Latin)', tag: 'ha-Latn'},
  {name: 'Hawaiian', tag: 'haw'},
  {name: 'Hebrew', tag: 'he'},
  {name: 'Hindi', tag: 'hi'},
  {name: 'Hungarian', tag: 'hu'},
  {name: 'Icelandic', tag: 'is'},
  {name: 'Igbo', tag: 'ig'},
  {name: 'Indonesian', tag: 'id'},
  {name: 'Interlingua', tag: 'ia'},
  {name: 'Inuktitut (Latin)', tag: 'iu-Latn'},
  {name: 'Inuktitut (Syllabics)', tag: 'iu-Cans'},
  {name: 'Irish', tag: 'ga'},
  {name: 'Italian', tag: 'it'},
  {name: 'Japanese', tag: 'ja'},
  {name: 'Jola-Fonyi', tag: 'dyo'},
  {name: 'Kabyle', tag: 'kab'},
  {name: 'Kako', tag: 'kkj'},
  {name: 'Kalenjin', tag: 'kln'},
  {name: 'Kamba', tag: 'kam'},
  {name: 'Kannada', tag: 'kn'},
  {name: 'Kazakh', tag: 'kk'},
  {name: 'Khmer', tag: 'km'},
  {name: "K'iche", tag: 'quc-Latn'},
  {name: 'Kikuyu', tag: 'ki'},
  {name: 'Kinyarwanda', tag: 'rw'},
  {name: 'Kiswahili', tag: 'sw'},
  {name: 'Konkani', tag: 'kok'},
  {name: 'Korean', tag: 'ko'},
  {name: 'Koyra Chiini', tag: 'khq'},
  {name: 'Koyraboro Senni', tag: 'ses'},
  {name: 'Kwasio', tag: 'nmg'},
  {name: 'Kyrgyz', tag: 'ky'},
  {name: 'Lakota', tag: 'lkt'},
  {name: 'Langi', tag: 'lag'},
  {name: 'Latvian', tag: 'lv'},
  {name: 'Lingala', tag: 'ln'},
  {name: 'Lithuanian', tag: 'lt'},
  {name: 'Low German ', tag: 'nds'},
  {name: 'Low German', tag: 'nds'},
  {name: 'Lower Sorbian', tag: 'dsb'},
  {name: 'Luo', tag: 'luo'},
  {name: 'Luxembourgish', tag: 'lb'},
  {name: 'Luyia', tag: 'luy'},
  {name: 'Machame', tag: 'jmc'},
  {name: 'Makhuwa-Meetto', tag: 'mgh'},
  {name: 'Makonde', tag: 'kde'},
  {name: 'Malagasy', tag: 'mg'},
  {name: 'Malay', tag: 'ms'},
  {name: 'Malayalam', tag: 'ml'},
  {name: 'Maltese', tag: 'mt'},
  {name: 'Manx', tag: 'gv'},
  {name: 'Maori', tag: 'mi'},
  {name: 'Mapudungun', tag: 'arn'},
  {name: 'Marathi', tag: 'mr'},
  {name: 'Masai', tag: 'mas'},
  {name: 'Mazanderani', tag: 'mzn'},
  {name: 'Meru', tag: 'mer'},
  {name: "Meta'", tag: 'mgo'},
  {name: 'Mohawk', tag: 'moh'},
  {name: 'Mongolian (Cyrillic)', tag: 'mn'},
  {name: 'Mongolian (Traditional)', tag: 'mn'},
  {name: 'Morisyen', tag: 'mfe'},
  {name: 'Mundang', tag: 'mua'},
  {name: "N'ko", tag: 'nqo'},
  {name: 'Nama', tag: 'naq'},
  {name: 'Nepali', tag: 'ne'},
  {name: 'Ngiemboon', tag: 'nnh'},
  {name: 'Ngomba', tag: 'jgo'},
  {name: 'Northern Luri', tag: 'lrc'},
  {name: 'North Ndebele', tag: 'nd'},
  {name: 'Norwegian (Bokmal)', tag: 'nb'},
  {name: 'Norwegian (Nynorsk)', tag: 'nn'},
  {name: 'Norwegian Bokmål', tag: 'nb'},
  {name: 'Nuer', tag: 'nus'},
  {name: 'Nyankole', tag: 'nyn'},
  {name: 'Occitan', tag: 'oc'},
  {name: 'Odia', tag: 'or'},
  {name: 'Oromo', tag: 'om'},
  {name: 'Pashto', tag: 'ps'},
  {name: 'Persian', tag: 'fa'},
  {name: 'Polish', tag: 'pl'},
  {name: 'Portuguese', tag: 'pt'},
  {name: 'Punjabi', tag: 'pa'},
  {name: 'Quechua', tag: 'quz'},
  {name: 'Ripuarian', tag: 'ksh'},
  {name: 'Romanian', tag: 'ro'},
  {name: 'Romansh', tag: 'rm'},
  {name: 'Rombo', tag: 'rof'},
  {name: 'Rundi', tag: 'rn'},
  {name: 'Russian', tag: 'ru'},
  {name: 'Rwa', tag: 'rwk'},
  {name: 'Saho', tag: 'ssy'},
  {name: 'Sakha', tag: 'sah'},
  {name: 'Samburu', tag: 'saq'},
  {name: 'Sami (Inari)', tag: 'smn'},
  {name: 'Sami (Lule)', tag: 'smj'},
  {name: 'Sami (Northern)', tag: 'se'},
  {name: 'Sami (Skolt)', tag: 'sms'},
  {name: 'Sami (Southern)', tag: 'sma'},
  {name: 'Sango', tag: 'sg'},
  {name: 'Sangu', tag: 'sbp'},
  {name: 'Sanskrit', tag: 'sa'},
  {name: 'Scottish Gaelic', tag: 'gd'},
  {name: 'Sena', tag: 'seh'},
  {name: 'Serbian (Cyrillic)', tag: 'sr-Cyrl'},
  {name: 'Serbian (Latin)', tag: 'sr-Latn'},
  {name: 'Sesotho sa Leboa', tag: 'nso'},
  {name: 'Setswana', tag: 'tn'},
  {name: 'Shambala', tag: 'ksb'},
  {name: 'Shona', tag: 'sn-Latn'},
  {name: 'Sinhala', tag: 'si'},
  {name: 'Slovak', tag: 'sk'},
  {name: 'Slovenian', tag: 'sl'},
  {name: 'Soga', tag: 'xog'},
  {name: 'Somali', tag: 'so'},
  {name: 'Sotho', tag: 'st'},
  {name: 'South Ndebele', tag: 'nr'},
  {name: 'Southern Sotho', tag: 'st'},
  {name: 'Spanish', tag: 'es'},
  {name: 'Standard Moroccan ', tag: 'zgh-Tfng'},
  {name: 'Swati', tag: 'ss'},
  {name: 'Swedish', tag: 'sv'},
  {name: 'Syriac', tag: 'syr'},
  {name: 'Tachelhit (Latin)', tag: 'shi-Latn'},
  {name: 'Taita', tag: 'dav'},
  {name: 'Tajik (Cyrillic)', tag: 'tg-Cyrl'},
  {name: 'Tamazight (Latin)', tag: 'tzm-Latn'},
  {name: 'Tamil', tag: 'ta'},
  {name: 'Tasawaq', tag: 'twq'},
  {name: 'Tatar', tag: 'tt'},
  {name: 'Telugu', tag: 'te'},
  {name: 'Teso', tag: 'teo'},
  {name: 'Thai', tag: 'th'},
  {name: 'Tibetan', tag: 'bo'},
  {name: 'Tigre', tag: 'tig'},
  {name: 'Tigrinya', tag: 'ti'},
  {name: 'Tongan', tag: 'to'},
  {name: 'Tsonga', tag: 'ts'},
  {name: 'Turkish', tag: 'tr'},
  {name: 'Turkmen', tag: 'tk'},
  {name: 'Ukrainian', tag: 'uk'},
  {name: 'Upper Sorbian', tag: 'hsb'},
  {name: 'Urdu', tag: 'ur'},
  {name: 'Uzbek (Cyrillic)', tag: 'uz-Cyrl'},
  {name: 'Uzbek (Latin)', tag: 'uz-Latn'},
  {name: 'Vai', tag: 'vai-Vaii'},
  {name: 'Vai (Latin)', tag: 'vai-Latn'},
  {name: 'Valencian', tag: 'ca'},
  {name: 'Venda', tag: 've'},
  {name: 'Vietnamese', tag: 'vi'},
  {name: 'Vunjo', tag: 'vun'},
  {name: 'Walser', tag: 'wae'},
  {name: 'Welsh', tag: 'cy'},
  {name: 'Wolaytta', tag: 'wal'},
  {name: 'Wolof', tag: 'wo'},
  {name: 'Xhosa', tag: 'xh'},
  {name: 'Yangben', tag: 'yav'},
  {name: 'Yoruba', tag: 'yo'},
  {name: 'Zarma', tag: 'dje'},
  {name: 'Zulu', tag: 'zu'},
];

// List adapted from: https://developers.taxjar.com/api/reference/#countries
export const commerceTaxJarCountryList: Array<string> = [
  // North America:
  'US',
  'CA',

  // Oceania:
  'AU',

  // European Union:
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',

  'GB', // << For now, lol
];

type CommerceUnitSystemOption = {
  code: string;
  name: string;
};

export const commerceUnitSystemOptions: Array<CommerceUnitSystemOption> = [
  {code: 'imperial', name: 'Imperial system'},
  {code: 'metric', name: 'Metric system'},
];
